import axios from '../../plugins/FinanceiroInterceptor'

export const state = {
}

export const mutations = {

}

export const getters = {
}
export const actions = {
    atualizarDescontos(context, payload) {
        console.log(payload)
        return new Promise((resolve, reject) => {
            axios.put(`descontos/editar-descontos/` + payload.contrato_id, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    obterDadosCondicoes(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`contratos/` + payload.contrato_id + `/calcular-condicoes`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

}



// WEBPACK FOOTER //
// ./src/store/modules/descontos.js